import React from "react";
import { useTranslation } from "lib/i18n/use-translation";
import ReportShell from "components/report/ReportShell";
import styles from "./AssessmentCalculatingUplift.module.scss";
import Ring01 from "Assets/images/assessment-calculating-ring01.svg";
import Ring02 from "Assets/images/assessment-calculating-ring02.svg";
import Ring03 from "Assets/images/assessment-calculating-ring03.svg";
import Ring04 from "Assets/images/assessment-calculating-ring04.svg";

const AssessmentCalculatingUplift: React.FC = () => {
  const { t } = useTranslation(["assessment"]);

  const body = (
    <>
      <div className={styles.rings}>
        <img src={Ring01} alt="" className={styles["ring-01"]} />
        <img src={Ring02} alt="" className={styles["ring-02"]} />
        <img src={Ring03} alt="" className={styles["ring-03"]} />
        <img src={Ring04} alt="" className={styles["ring-04"]} />
      </div>
      <p className={styles.heading}>
        {t("assessment:interstitial.calculatingScore")}
      </p>
    </>
  );

  // The report frame, so the wait and the report that follows it are the
  // same shape and nothing jumps between them. The sky is bright, as on the
  // cover it leads into. There is no close control: the submit is already in
  // flight.
  return (
    <div data-testid="assessment-calculating-uplift">
      <ReportShell showSky brightSky>
        {body}
      </ReportShell>
    </div>
  );
};

export default AssessmentCalculatingUplift;
